<template>
  <v-card>
    <v-toolbar dark color="blue">
      <v-btn icon dark @click.native="close" :disabled="loading">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>เจ้าหน้าที่</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field required
                disabled
                label="Username"
                v-model="item.username"
                :rules="[rules.required]"
                append-icon="search"
                @click:append="lookupUsername(item.username)"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-radio-group v-model="item.enabled" row @change="onChange">
                <v-radio label="เปิดสิทธิการใช้งาน" :value="true" color="green"></v-radio>
                <v-radio label="ปิดสิทธิการใช้งาน" :value="false" color="red"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field required @change="onChange"
                label="ชื่อ"
                v-model="item.firstname"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field required @change="onChange"
                label="นามสกุล"
                v-model="item.lastname"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field required @change="onChange"
                label="ชื่อเต็ม"
                v-model="item.fullname"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field required @change="onChange"
                label="อีเมล"
                v-model="item.email"
                :rules="[rules.required, rules.email]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select @input="onChange"
                :items="gangList"
                v-model="item.gangs"
                return-object
                :item-text="gangText"
                item-value="id"
                label="บทบาท"
                multiple
                chips
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="item.assignedCompanies && (item.assignedCompanies.length > 0)">
              <v-toolbar dark color="primary">
                <v-toolbar-title class="white--text">บริษัทที่รับผิดชอบ</v-toolbar-title>
              </v-toolbar>
              <v-data-table
                  :headers="companyHeaders"
                  :items="item.assignedCompanies"
                  hide-actions
                >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-center">{{ props.index + 1 }}</td>
                  <td class="text-xs-left" nowrap>{{ props.item.code }}</td>
                  <td class="text-xs-left">
                    {{ props.item.name }}
                  </td>
                  <td class="text-xs-center">
                    {{ $t(`company_type.${props.item.companyType}`) }}
                  </td>
                  <td class="text-xs-center">
                    <v-icon color="green" v-if="props.item.enabled">check</v-icon>
                    <v-icon color="red" v-else>report_problem</v-icon>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pl-3 pr-3">
      <v-btn color="grey darken-2 white--text" @click.native="close" :loading="loading">ปิด</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ShowOfficerDialog',
  props: [ 'dialog', 'officer' ],
  data () {
    return {
      loading: false,
      valid: false,
      companyHeaders: [
        { text: '#', value: 'idx', sortable: false, align: 'center' },
        { text: 'เลขที่ผู้เสียภาษี', value: 'code', sortable: true, align: 'left' },
        { text: 'ผู้รับใบอนุญาต', value: 'name', sortable: true, align: 'left' },
        { text: 'ประเภท', value: 'companyType', sortable: true, align: 'center' },
        { text: 'เปิดใช้งาน', value: 'enabled', sortable: true, align: 'center' }
      ],
      item: this.officer,
      gangList: [],
      rules: {
        required: value => !!value || 'กรุณากรอกข้อมูล.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'รูปแบบอีเมลไม่ถูกต้อง.'
        }
      }
    }
  },
  methods: {
    gangText: item => item.authority + ' : ' + item.description,
    close () {
      this.$events.fire('closeDialog', 'editedDialog')
    },
    onChange () {
      this.update(this)
    },
    update: _.debounce((self) => {
      if (self.$refs.form.validate()) {
        self.loading = true
        self.$store.dispatch('officer/update', {
          id: self.item.id,
          firstname: self.item.firstname,
          lastname: self.item.lastname,
          fullname: self.item.fullname,
          enabled: self.item.enabled,
          gangs: self.item.gangs
        }).then(response => {
          self.$snotify.success('บันทึกเรียบร้อย!', 'เรียบร้อย!')
          self.loading = false
        }).catch(error => {
          this.loading = false
          self.$snotify.error(`${error.response.data.error}:${error.response.data.message}`, 'ไม่สำเร็จ!')
        })
      }
    }, 1000)
  },
  created () {
    this.$store.dispatch('gang/list')
      .then(response => {
        this.gangList = response.data
      })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/officer/showOfficerDialog.vue